import { Injectable } from '@angular/core'

export enum LocalSettingsKeys {
  recentRoutes = 'recentRoutes',
  favoriteRoutes = 'favoriteRoutes',
}

export type LocalSettingsKey = keyof typeof LocalSettingsKeys

@Injectable({ providedIn: 'root' })
export class LocalSettingsService {
  private getFromLocalStorage(key: LocalSettingsKey): unknown {
    const rawJson = localStorage.getItem(key)
    if (rawJson) {
      try {
        return JSON.parse(rawJson)
      } catch {
        // ignore
      }
    }
    return undefined
  }

  getValue<T>(key: LocalSettingsKey, toValue: (raw: unknown) => T | undefined): T | undefined {
    const result = this.getFromLocalStorage(key)
    return result == null ? undefined : toValue(result)
  }

  getArrayValue<T>(key: LocalSettingsKey, toSingleValue: (raw: unknown) => T | undefined): readonly T[] {
    const toValue = (raw: unknown): readonly T[] => {
      if (Array.isArray(raw)) {
        return raw.map(toSingleValue).filter((r)=> r !== undefined)
      } else {
        return []
      }
    }
    return this.getValue(key, toValue) ?? []
  }

  putValue(key: LocalSettingsKey, value: unknown) {
    localStorage.setItem(key, JSON.stringify(value))
  }
}

